import type billingEn from "./billing.en";

const billingAr: Record<keyof typeof billingEn, string> = {
  "settings.billing": "الفوترة",
  "settings.billing_hint": "البطاقة والفواتير وبيانات الفوترة",
  "bill.banner_past_due": "تعذّر تحصيل اشتراك سوقنا. ادفع الآن ليبقى متجرك مفتوحاً.",
  "bill.banner_frozen": "متجرك مجمّد بسبب فاتورة غير مدفوعة: لا يراه المتسوقون ولا تعمل هنا إلا الفوترة. ادفع الآن لإعادة فتحه.",
  "bill.status.trialing": "تجربة مجانية",
  "bill.status.active": "نشط",
  "bill.status.past_due": "دفعة مستحقة",
  "bill.status.frozen": "مجمّد",
  "bill.status.paused": "متوقف مؤقتاً",
  "bill.status.cancelled": "ملغى",
  "bill.frozen": "تم تجميد متجرك بسبب فاتورة غير مدفوعة بقيمة {amount}: يرى المتسوقون صفحة كلمة مرور. ادفع الآن لإعادة فتحه فوراً. تُغلق المتاجر غير المدفوعة في {date}.",
  "bill.past_due": "لم تنجح دفعتك الأخيرة. ادفع أو حدّث بطاقتك قبل {date} ليبقى متجرك مفتوحاً.",
  "bill.cancelling": "ينتهي اشتراكك في {date}. استأنفه قبل ذلك ليبقى متجرك مفتوحاً.",
  "bill.checking": "نتحقق من دفعتك لدى SkipCash…",
  "bill.paid_done": "تم استلام الدفعة. شكراً لك!",
  "bill.paid_pending": "ما زلنا ننتظر تأكيد SkipCash لدفعتك. ستتحدث هذه الصفحة عند التأكيد.",
  "bill.paid_failed": "لم تنجح الدفعة. حاول مرة أخرى أو استخدم بطاقة أخرى.",
  "bill.next_charge": "الخصم القادم: {amount} في {date}",
  "bill.card": "{brand} تنتهي بـ {last4}",
  "bill.offline": "الدفع الإلكتروني غير متاح بعد. سنرسل لك فاتورة للدفع بتحويل بنكي.",
  "bill.pay_now": "ادفع الآن",
  "bill.pay_amount": "ادفع {amount}",
  "bill.resume": "استئناف الاشتراك",
  "bill.cancel": "إلغاء الاشتراك",
  "bill.cancel_title": "إلغاء اشتراكك؟",
  "bill.cancel_confirm": "يبقى متجرك مفتوحاً حتى نهاية الفترة المدفوعة ثم يُغلق. يمكنك الاستئناف حتى يومين قبل ذلك تقريباً.",
  "bill.usage": "الاستخدام",
  "bill.meter_staff": "حسابات الموظفين",
  "bill.meter_locations": "المواقع",
  "bill.meter_languages": "اللغات",
  "bill.meter_storage": "مساحة الملفات",
  "bill.plan_locations": "{n} مواقع",
  "bill.your_plan": "باقتك",
  "bill.subscribe": "اشترك",
  "bill.switch": "التبديل إلى هذه الباقة",
  "bill.choose": "اختر الباقة",
  "bill.choose_title": "باقة {plan}",
  "bill.due_now": "المستحق الآن",
  "bill.then": "ثم {amount} شهرياً، تُخصم تلقائياً ابتداءً من {date}.",
  "bill.credit_left": "يُحفظ {amount} من الوقت غير المستخدم رصيداً في حسابك.",
  "bill.promo": "رمز ترويجي",
  "bill.apply": "تطبيق",
  "bill.redirect_note": "ستدفع بأمان على صفحة SkipCash ثم تعود إلى هنا مباشرة.",
  "bill.payment_method": "طريقة الدفع",
  "bill.by_transfer": "الدفع بتحويل بنكي مقابل فواتيرنا.",
  "bill.no_card": "لا توجد بطاقة بعد: تُضاف عند اختيار باقة.",
  "bill.update_card": "تحديث البطاقة",
  "bill.update_card_note": "تغيير البطاقة يتطلب دفعة تحقق بقيمة 5 ريال على صفحة SkipCash.",
  "bill.upcoming": "القادم",
  "bill.no_upcoming": "لا شيء مجدول.",
  "bill.amount_due": "المبلغ المستحق: {amount}",
  "bill.credits": "رصيد الحساب",
  "bill.credits_note": "يُستخدم تلقائياً في دفعة باقتك القادمة.",
  "bill.invoices": "الفواتير",
  "bill.no_invoices": "لا توجد فواتير بعد.",
  "bill.inv_number": "الفاتورة",
  "bill.inv_date": "التاريخ",
  "bill.inv_status": "الحالة",
  "bill.inv_total": "الإجمالي",
  "bill.inv.draft": "مسودة",
  "bill.inv.open": "مستحقة",
  "bill.inv.paid": "مدفوعة",
  "bill.inv.void": "ملغاة",
  "bill.inv.uncollectible": "لم تُحصّل",
  "bill.refunded": "تم استرداد {amount}",
  "bill.view": "عرض الفاتورة",
  "bill.download": "تنزيل PDF",
  "bill.profile": "بيانات الفوترة",
  "bill.profile_hint": "تُطبع على الفواتير التي ترسلها لك سوقنا.",
  "bill.legal_name": "الاسم القانوني للنشاط",
  "bill.billing_email": "بريد الفوترة",
  "bill.tax_id": "رقم التسجيل الضريبي",
  "bill.phone": "الهاتف",
  "bill.address": "العنوان",
  "bill.city": "المدينة",
};

export default billingAr;
